import { Routes, Route } from "react-router-dom";
import  About  from "./components/About1";
import  Portfolio from "./components/Port1";
import Navbar from "./components/Navbar";
import Service from "./components/Service";
import Contact from "./components/Contact";
import Home from "./components/Home";
import Product from "./components/product1";
import Pri from "./components/pri";
import Dis from "./components/dis";
import Tc from "./components/tc";
import Conf from "./components/conf";
import Ref from "./components/ref";
import Form from "./components/form";


function App() {
    return (
        <>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/service" element={<Service />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/products" element={<Product />} />
                <Route path="/pri" element={<Pri />} />
                <Route path="/dis" element={<Dis />} />
                <Route path="/tc" element={<Tc />} />
                <Route path="/conf" element={<Conf />} />
                <Route path="/ref" element={<Ref />} />
                <Route path="/form" element={<Form />} />

            </Routes>
        </>
    );
}

export default App;

